import React from "react";
import { motion } from "framer-motion";
import { Target } from "lucide-react";

export const PreorderProgress = ({ stats = { reserved: 0, goal: 300, percent: 0 } }) => {
  const pct = Math.max(0, Math.min(100, stats.percent || 0));

  return (
    <div
      data-testid="preorder-progress"
      className="mt-12 max-w-2xl bg-sf-surface border border-sf-border rounded-md p-6"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          <Target size={16} className="text-sf-ember" />
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-sf-dim">
            First-Wave Progress
          </span>
        </div>
        <span
          data-testid="preorder-progress-count"
          className="font-mono text-xs uppercase tracking-[0.15em] text-sf-bone"
        >
          <span className="text-sf-ember">{stats.reserved}</span> / {stats.goal} reserved
        </span>
      </div>

      <div className="relative h-2.5 w-full rounded-full bg-sf-bg overflow-hidden border border-sf-border">
        <motion.div
          className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-sf-emberDeep to-sf-emberBright"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>

      <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.15em] text-sf-muted">
        {stats.reserved >= stats.goal
          ? "Goal reached — first-wave production is a go."
          : `No payment until we reach ${stats.goal}. Reserve free to push us there.`}
      </p>
    </div>
  );
};

export default PreorderProgress;
